import React, { Fragment, useCallback } from 'react';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Heading, Radio, Box, Text } from '@qga/roo-ui/components';
import FilterLabel from 'components/Filters/FilterLabel';
import { SORT_SELECT_OPTIONS } from 'lib/enums/search';
import FilterContainer from 'components/Filters/FilterContainer';
import { getQuerySortBy } from 'store/router/routerSelectors';

const SortLabel = styled(FilterLabel)`
  display: flex;

  &:last-of-type {
    border: 0;
  }
`;
SortLabel.displayName = 'SortLabel';

const Sort = ({ onChange, displayHeading }) => {
  const sortBy = useSelector(getQuerySortBy);

  const onClickSortOption = useCallback(
    (sortOptionValue) => () => {
      onChange({ sortBy: sortOptionValue });
    },
    [onChange],
  );

  const isChecked = useCallback((sortOptionValue) => sortOptionValue === sortBy, [sortBy]);

  return (
    <Fragment>
      {displayHeading && <Heading.h2 fontSize="sm">Sort by</Heading.h2>}
      <FilterContainer>
        {SORT_SELECT_OPTIONS.map((sortOption) => (
          <SortLabel key={sortOption.value} isChecked={isChecked(sortOption.value)}>
            <Box as="form">
              <Radio
                name="sort"
                value={sortOption.value}
                onChange={onClickSortOption(sortOption.value)}
                checked={isChecked(sortOption.value)}
              />
            </Box>
            <Text fontSize="sm" fontWeight="inherit">
              {sortOption.label}
            </Text>
          </SortLabel>
        ))}
      </FilterContainer>
    </Fragment>
  );
};

Sort.propTypes = {
  onChange: PropTypes.func,
  displayHeading: PropTypes.bool,
};

Sort.defaultProps = {
  onChange: () => {},
  displayHeading: true,
};

export default Sort;
